import { faBath } from '@fortawesome/pro-light-svg-icons'
import {
  ResidentialApartmentPropertyDetails,
  ResidentialHousePropertyDetails,
} from '@unreserved-frontend-v2/api/generated/graphql/types'
import { DetailsTableCell } from '@unreserved-frontend-v2/ui/details-table/models'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'

export const useBathsCell = (
  details?: ResidentialApartmentPropertyDetails | ResidentialHousePropertyDetails | null
): DetailsTableCell => {
  const { t } = useTranslation()
  return useMemo(() => {
    let value = ''

    if (details?.bathsFull) {
      value = t('listings:details-pages.full', { count: details.bathsFull })
    }

    if (details?.bathsEnsuite) {
      value = `${t('listings:details-pages.ensuite', {
        count: details.bathsEnsuite,
      })} - ${value}`
    }

    if (details?.bathsPartial) {
      value = `${value} - ${t('listings:details-pages.partial', {
        count: details.bathsPartial,
      })}`
    }

    return {
      id: 'baths',
      cellClassName: 'md:border-0',
      data: [
        {
          id: 'data-baths',
          icon: faBath,
          iconCount: details?.baths || 0,
          label: t('listings:details-pages.baths', { count: details?.baths }),
          value: value,
          type: 'iconCounter',
        },
      ],
    }
  }, [details, t])
}
